<template>
    <div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="132.7px"
	 height="177.3px" viewBox="0 0 132.7 177.3" style="enable-background:new 0 0 132.7 177.3;" xml:space="preserve">
<g id="boton2" @click="evaluar()">
	
		<image style="overflow:visible;" width="119" height="119" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAB3CAYAAAA5Od+KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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" transform="matrix(1 0 0 1 6.6665 7.2808)">
	</image>
	<g id="XMLID_2790_">
		<rect id="XMLID_11_" x="10.6" y="140.4" class="st3" width="111.5" height="29.5"/>
		<text transform="matrix(1 0 0 1 25.5337 152.436)" class="st2 st1 st4">Flash Point  </text>
	</g>
	<linearGradient id="XMLID_3_" gradientUnits="userSpaceOnUse" x1="4.4214" y1="66.7808" x2="128.2456" y2="66.7808">
		<stop  offset="0" style="stop-color:#23CAD9"/>
		<stop  offset="0.9898" style="stop-color:#32ADF0"/>
	</linearGradient>
	<circle id="XMLID_2618_" class="st0" cx="66.3" cy="66.8" r="59.4"/>
</g>
<g id="check2" :class="visto ?'mostrar':'esconder'">
	
		<image style="overflow:visible;" width="26" height="26" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
bWFnZVJlYWR5ccllPAAAAsVJREFUeNpiYKATYCRGkeTcIAUgFcDwn0EfSCsgSX0AmnARSG94nrzu
AtkWycwPMvj/n6EebAlh8ICRkaHxSeK6BSRZJLsgqB9IFZARSgeAFgY+il/3Aa9FCouDBIC+WA9k
OlAQJR+Aljk+iEUEJxO6CiZGhvnMTAwOQMxAARYAmrNfaWmwAMxcFmRLVJYFNxAZH8QAkCWgkHFE
CTq1lcEKwFR1HqqAJMDLys3Ax8bN8PTrK2zSibci1i5gQgqyfCaQl4EipOJO82yGje7dDFpCCtjk
61F8pLUm+D05vmk1yWEIkIekm8+/vzJ0XFzAsOHhfnRlhuA40lkX7ECOJf5yjnBLYEHICPUJGggA
WwSUMCDVEkdJM4YW42wUsaX3tjJsfrwfm0X2MItI8o06nwJDsyGqJZsfH2DouTofmyWIfIQvT4CC
p8kwB87nZ+dmmG3VCA4mGLj16QFD7/X5eM2B+Qgr8JZ2ZKjXy4YXIX035jPMMEO15Pn31wwZp+oZ
vv39itMceIYFKniALqHKqwC3BAR8ZBwY7CVMGXhZEJZ8+fOVofx8J0FLQEUSE9SiC+jp/+7XBwzb
nh1AzZhIloBAxYUuhjtAdUTktYPwfGS9J/g+Wl0DBmFy3gx5qokYTmy7NpVh2/P9xKYfQ0TJwMSw
EFskrn2ylaH9xlQUXauBYjtf7ieqgAWae+Coy9oLyEXQBGBm+4DN67uAhnbchFi24+UBhml355NS
RDVi1EeOh4IDGCElLlZgLWzGcOHjVYavwERADPjPwLBgv93aRKwVn/ORkH5G8mpWdEsuMPz/77jX
du0HnFW527EQcqtxGLgArKUdd1uv+UCwzeB+PCQAWB3PJ6OwnbDDYk0hSa0gz5MhAkDLQD6Lx5b0
0cACoC8at5uveUB2uw5cMpwOMQA3WBjRfPifAZSrL2wxXfMBn36AAAMAZz7LJ6pPpnwAAAAASUVO
RK5CYII=" transform="matrix(1 0 0 1 96.7456 10.9995)">
	</image>
</g>
</svg>
        <modal-app v-model="modala" :fullscreen="false" width="700px">
            <template slot="modaltittle">
            </template>

            <template slot="modalcontent">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 md6>
                        <img class="img-fluid" src="@/assets/unidad1/pantalla-4-3.png" alt="">
                    </v-flex>
                    <v-flex xs12 md6>
                        <h2>Flash Point</h2>
                        <p>Mínima temperatura a la cual un líquido desprende suficientes <strong>vapores</strong> para
                            formar mezclas inflamables.</p>
                    </v-flex>
                </v-layout>
            </template>
        </modal-app>
    </div>
</template>

<script>
    import nextConditions from "../../../js/mixins/nextConditions";
    export default {
        mixins: [nextConditions],
        data() {
            return {
                visto: false,
                modala: false
            }
        },
        methods: {
            evaluar() {
                this.modala = true;
                this.visto = true;
                this.$store.commit('vistosUnidad1Mod32', this.visto)
                if (this.$store.state.vistosUnidad1Mod31 && this.$store.state.vistosUnidad1Mod32 && this.$store.state
                    .vistosUnidad1Mod33 && this.$store.state.vistosUnidad1Mod34) {
                    this.$store.commit('vistosAllMod3', true)
                }
            }
        },
        mounted() {},
    }
</script>


<style lang="scss" scoped>
    svg {
        cursor: pointer;
    }

    .mostrar {
        display: block;
    }

    .esconder {
        display: none;
    }

	.st0{fill:none;stroke:url(#XMLID_3_);stroke-width:5;stroke-miterlimit:10;}
	.st1{font-family:'FontBase-SemiBold';}
	.st2{fill:#2D2D2D;}
	.st3{fill:none;}
	.st4{font-size:17;}
</style>